import { GetListParams } from 'react-admin'
import StackAPI from '../../../lib/StackAPI'
import Storage from '../../../lib/Storage'

export interface OrgUserResponse {
  id: string
  attributes: {
    first_name: string
    last_name: string
    email: string
  }
}

export interface GetOrgUsersResponse {
  data: Array<OrgUserResponse>
  meta: {
    record_count: number
  }
}

const urlBuilder = (orgId: string, offset: number, page: number) =>
  `/api/org_users?filter[org_id]=${orgId}&page[offset]=${offset}&page[limit]=${page}`

export const getOrgUsers = async (
  params: GetListParams
): Promise<GetOrgUsersResponse> => {
  const { get } = StackAPI()
  const { organizationId: orgId } = Storage().getActiveRole()
  const { pagination } = params

  const offset = ((pagination?.page ?? 1) - 1) * (pagination?.perPage ?? 10)
  const limit = pagination?.perPage ?? 10

  const headers = {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json'
  }

  const request = {
    path: urlBuilder(orgId, offset, limit),
    headers
  }

  return await get(request)
    .then(({ data, status }) =>
      status === 200
        ? (data as GetOrgUsersResponse)
        : { data: [], meta: { record_count: 0 } }
    )
    .catch(() => ({ data: [], meta: { record_count: 0 } }))
}
